import React from 'react';
import { CardListItemBaseProps } from '@hevoio/hevo-ui-toolkit';
import { Activation } from '../../models/activation';
import { ActivationListItem } from './ActivationListItem/ActivationListItem';
import ActivationsAPI from '../../api/ActivationsAPI';

export function ActivationListCardItem({ data: activation, refresh }: CardListItemBaseProps<Activation>) {
  const resumeActivation = async () => {
    await ActivationsAPI.resumeActivation(activation.id);
    refresh();
  };

  const pauseActivation = async () => {
    await ActivationsAPI.pauseActivation(activation.id);
    refresh();
  };

  return (
    <ActivationListItem
      activation={activation}
      dataId={activation.id.toString()}
      pauseActivation={pauseActivation}
      resumeActivation={resumeActivation}
    />
  );
}
